<template>
  <div class="user-box">
    <dl v-if="name">
      <dt>name</dt>
      <dd>{{name}}</dd>
    </dl>
    <dl class="pb-2">
      <dt>unique ID</dt>
      <dd>{{uid}}</dd>
    </dl>

    <div v-if="user.birthCountry">
      <dl class="pb-2">
        <dt>address</dt>
        <dd>{{user.address}}</dd>
        <dt>zip</dt>
        <dd>{{user.zip}}</dd>
        <dt>country of residence</dt>
        <dd>{{user.residentCountry}}</dd>
        <dt>place of residence</dt>
        <dd>{{user.residentPlace}}</dd>
      </dl>

      <dl>
        <dt>date of birth</dt>
        <dd>{{user.dateOfBirth}}</dd>
        <dt>country of birth</dt>
        <dd>{{user.birthCountry}}</dd>
        <dt>place of birth</dt>
        <dd>{{user.birthPlace}}</dd>
      </dl>
      <dl v-if="user.telephone">
        <dt>telephone</dt>
        <dd>{{user.telephone}}</dd>
      </dl>

      <dl v-if="user.instagram">
        <dt>instagram</dt>
        <dd>
          <a :href="'https://www.instagram.com/'+user.instagram">{{user.instagram}}</a>
        </dd>
      </dl>
      <dl v-if="user.twitter">
        <dt>twitter</dt>
        <dd>
          <a :href="'https://twitter.com/'+user.twitter">{{user.twitter}}</a>
        </dd>
      </dl>
      <dl v-if="user.website">
        <dt>website</dt>
        <dd>{{user.website}}</dd>
      </dl>
    </div>
  </div>
  <!--.user-box -->
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    uid: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
dl {
}
dt {
  font-weight: 500;
  color: rgba(92, 92, 92, 0.9);
  font-size: 0.9em;
}
dd {
  font-size: 1.15em;
}
</style>
